var map = {
	"./beefBurger.jpg": 6565,
	"./beefSandwich.jpg": 8652,
	"./beefSandwichBurger.png": 2502,
	"./blankStar.png": 1384,
	"./blankStar1.png": 7170,
	"./burger-background.png": 6557,
	"./burger-poster.jpg": 3740,
	"./burger1.jpg": 4183,
	"./burger2.jpg": 1234,
	"./burger3.jpg": 9443,
	"./burgerCharming.jpg": 3261,
	"./burgerPlusFries.jpg": 4171,
	"./burgerPoster.jpg": 3579,
	"./burgerlogo.png": 6172,
	"./burgerposter2.png": 4838,
	"./canvas.jpg": 6642,
	"./chief.jpg": 3770,
	"./chris.jpg": 3309,
	"./customericon.jpg": 986,
	"./doubleCheeseburger.jpg": 4073,
	"./eaterGirl.jpg": 3721,
	"./eaterMan.jpg": 1940,
	"./fbicon.png": 8183,
	"./foodEater.png": 7177,
	"./freshBurger.jpg": 5884,
	"./fries.jpg": 3317,
	"./githubicon.png": 8916,
	"./gmailicon.png": 7235,
	"./goldStar.png": 6640,
	"./homeburger.png": 4320,
	"./jetblackburger.jpg": 5947,
	"./linkedinicon.png": 2955,
	"./myat.jpg": 4487,
	"./oneBurgerSet.jpg": 3249,
	"./phoneicon.png": 9360,
	"./remove.png": 2205,
	"./shoppingCart.png": 7008,
	"./spicyBurger.jpg": 4827,
	"./tom.png": 7083,
	"./tripleBeefBurger.jpg": 3163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;